
import React from 'react';
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function DashboardCards({ cards }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = (card) => {
        if(card.type === 'linkExtern'){
            window.open(card.link, '_blank');
        }
        else {
            navigate(card.link)
        }
    }
    return (
        <Row>
            {cards.map((card, index) => {
                const isDisabled = card.disabled;

                return (
                    <Col sm="12" md="6" xl="6" className="mb-4" key={index}>
                        <Card 
                            aria-disabled={isDisabled}
                            onClick={!isDisabled && card.link ? () => handleClick(card) : undefined}
                            className="h-100 text-center shadow-sm border-0"
                            style={{
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                backgroundColor: isDisabled ? '#f8f9fa' : 'white',
                                opacity: isDisabled ? 0.5 : 1,
                                pointerEvents: isDisabled ? 'none' : 'auto'
                            }}
                        >
                            <CardBody>
                                <div className="mb-3">
                                    <FontAwesomeIcon icon={card.icon} size="2x" />
                                </div>
                                <CardTitle tag="h5">{t(card.title)}</CardTitle>
                                {card.text && <p className="text-muted">{t(card.text)}</p>}
                            </CardBody>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
}

export default DashboardCards;
